"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var previousroute_service_1 = require("./../../../Services/previousroute.service");
var geolocation_service_1 = require("./../../../Services/geolocation.service");
var subscribtion_service_1 = require("./../../../Services/subscribtion.service");
var router_1 = require("@angular/router");
var service_service_1 = require("src/app/Services/service.service");
var forms_1 = require("@angular/forms");
var http_1 = require("@angular/common/http");
var captcha_service_1 = require("./../../../Services/captcha.service");
var adv_edit_component_1 = require("./../../../Adveristments/adv-edit/adv-edit.component");
var core_1 = require("@angular/core");
var AdView;
(function (AdView) {
    AdView[AdView["Advertisement"] = 0] = "Advertisement";
    AdView[AdView["Payment"] = 1] = "Payment";
})(AdView = exports.AdView || (exports.AdView = {}));
var AdType;
(function (AdType) {
    AdType[AdType["Free"] = 0] = "Free";
    AdType[AdType["Premium"] = 1] = "Premium";
})(AdType = exports.AdType || (exports.AdType = {}));
var AdvEditComponent = /** @class */ (function (_super) {
    __extends(AdvEditComponent, _super);
    function AdvEditComponent(captchaService, HttpClient, fb, services, route, subscriptionService, geolocationService, previouseRouteService, router) {
        return _super.call(this, captchaService, HttpClient, fb, services, route, subscriptionService, geolocationService, previouseRouteService, router) || this;
    }
    AdvEditComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (_super.prototype.isNew.call(this)) {
            this.services.pageName = "Add Advertisement";
        }
        else if (!_super.prototype.isNew.call(this) && !this.SpecialUser && !this.Expired) {
            this.services.pageName = "Edit Advertisement";
        }
        else if (this.SpecialUser && !this.Expired) {
            this.services.pageName = "Premium Verified Ad";
        }
        else if (this.Expired) {
            this.services.pageName = "Expired";
        }
        document.getElementById('scroll-view-content').scrollTop = 0;
    };
    AdvEditComponent.prototype.ngAfterViewInit = function () {
    };
    AdvEditComponent.prototype.scrollView = function (e) {
    };
    return AdvEditComponent;
}(adv_edit_component_1.AdvEditComponent));
exports.AdvEditComponent = AdvEditComponent;
